<template>
  <div
    v-if="modalData"
    class="designer__page"
  >
    <div :class="[isSidebarOpened ? 'opened' : '', 'page__content']">
      <b-card
        class="layout__wrapper"
        no-body
      >
        <designer-actions />
        <b-card-body
          ref="layout__wrapper"
          class="main-card"
        >
          <designer-grid-layout
            v-for="layout of renderList"
            :key="layout.id"
            :container-id="layout.id"
            :styles="layout.styles || null"
            :is-placeholder="layout.Placeholder || layout.isHidden"
            :title="layout.Name"
            :layout="layout.Fields"
            :is-editable="true"
            @get-parent-refs="getParentRefsHandler"
          />
        </b-card-body>
      </b-card>
      <div class="sidebar__container">
        <designer-sidebar v-if="isSidebarOpened" />
        <button
          class="sidebar__wrapper--action"
          @click="onSidebarBtnClick"
        >
          <font-awesome-icon :icon="['fas', getCurrentSidebarIcon]" />
        </button>
      </div>
    </div>
    <designer-customisations-modal v-if="isCustomisationModalOpened" />
  </div>
</template>

<script>
import DesignerGridLayout from '@/core/components/complex-table/DesignerGridLayout.vue';
import {createNamespacedHelpers} from 'vuex';
import DesignerActions from '@/modules/DataManagement/views/designer/components/DesignerActions.vue';
import DesignerSidebar from '@/modules/DataManagement/views/designer/components/DesignerSidebar.vue';
import DesignerCustomisationsModal
  from '@/modules/DataManagement/views/designer/components/modals/DesignerCustomisationsModal.vue';


const {
  mapState: designerMapState,
  mapActions: designerMapActions,
} = createNamespacedHelpers('designer');

export default {
  name: 'DesignerView',
  components: {
    DesignerCustomisationsModal,
    DesignerSidebar,
    DesignerActions,
    DesignerGridLayout,
  },
  data() {
    return {
      parentRefs: {},
      data: null,
      sectionsToRender: null,
      isHighlight: false,
    };
  },
  watch: {
    computedObjectToBeWatched: {
      handler(val, oldVal) {
        const ref = this.$refs.layout__wrapper;
        if (val.Sections.length > oldVal.Sections.length) {
          this.$nextTick(() => {
            ref.scrollTo({
              behavior: 'smooth',
              top: ref.scrollHeight + ref.offsetHeight,
            });
          });
        }
      },
      deep: true,
    },
    searchValue(val) {
      const sectionsBackup = JSON.parse(JSON.stringify(this.modalData.Sections));
      const res = sectionsBackup.filter(section => {
        const isValExistInFields = section.Fields.some(f => (
          this.fields[f.fieldGuid]?.displayName.toLowerCase().includes(val)
        ));
        if (section.Name.toLowerCase().includes(val) || isValExistInFields) {
          return section;
        }
      });
      this.sectionsToRender = res;
    },
  },
  computed: {
    ...designerMapState({
      modalData: state => state.data,
      fields: state => state.fields,
      isSidebarOpened: state => state.isDesignerSidebarOpened,
      isCustomisationModalOpened: state => state.customisationsModal.isOpen,
      searchValue: state => state.searchValue,
      isSettingsWasChanged: state => state.isSettingsWasChanged,
    }),
    getCurrentSidebarIcon() {
      return this.isSidebarOpened ? 'chevron-right' : 'chevron-left';
    },
    renderList() {
      if (this.searchValue.length && this.$refs.layout__wrapper) {
        this.$refs.layout__wrapper.scrollTo({
          behavior: 'smooth',
          top: 0,
        });
        return this.sectionsToRender;
      } else {
        return this.modalData.Sections;
      }
    },
    computedObjectToBeWatched() {
      return JSON.parse(JSON.stringify(this.modalData));
    },
  },
  methods: {
    ...designerMapActions([
      'setParentRefs',
      'openDesignerSidebar',
      'closeDesignerSidebar',
      'setSearchValue',
    ]),
    onSidebarBtnClick() {
      this.isSidebarOpened ? this.closeDesignerSidebar() : this.openDesignerSidebar();
    },
    getParentRefsHandler(parent) {
      const {id, ref} = parent;
      this.parentRefs[id] = ref;

      this.setParentRefs(this.parentRefs);
    },
  },
};
</script>
<style>

.layout__wrapper .card-body.main-card {
  height: 75vh;
  overflow-y: auto;
  padding: 10px;
}

.page__content {
  display: grid;
  grid-template-columns: 3fr auto;

  &.opened {
    grid-template-columns: 3fr 1fr;
    column-gap: 20px;
  }
}

.sidebar__container {
  position: relative;
}

.sidebar__wrapper--action {
  z-index: 1000;
  padding: 5px 2px;
  background: #d5d5d5;
  color: #fff;
  font-size: 18px;
  -webkit-transition: all 0.3s;
  transition: all 0.3s;
  border-radius: 2px;
  position: absolute;
  border: none;
  top: 50%;
  left: 0;
  transform: translate(-100%, -50%);

  &:focus {
    outline: none;
  }
}
</style>